<template>
  <v-container fluid class="error-page fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="4" class="text-center">
        <v-icon size="64" color="warning" class="mb-4">mdi-shield-lock-outline</v-icon>
        <h2 class="error-title mb-2">{{ $t('serviceUnavailable') }}</h2>
        <p class="error-hint mb-6">{{ $t('serviceUnavailableHint') }}</p>
        <v-btn v-if="retryDisabled" color="warning" outlined @click="manualRetry" class="mb-4">
          {{ $t('retry') || 'Retry' }}
        </v-btn>
        <div>
          <span class="ref-code">{{ $t('refCode') }} E-100</span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import errorRetryMixin from './errorRetryMixin';

export default {
  name: 'ErrorSession',
  mixins: [errorRetryMixin],
};
</script>

<style scoped>
.error-page   { background: #1a1a1a; min-height: 100%; }
.error-title  { color: #fff; font-size: var(--font-size-7xl); font-weight: 700; }
.error-hint   { color: #888; font-size: var(--font-size-3xl); }
.ref-code     { color: #444; font-size: var(--font-size-xl); letter-spacing: 1px; }
</style>
